// extracted by mini-css-extract-plugin
export default {"card":"NFBfqPU7bVhP2Yb1+rQ+Ww=="};